"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AuAnalytics = _interopRequireDefault(require("../../utils/AuAnalytics"));
var _ClientSideError = _interopRequireDefault(require("./ClientSideError"));
class GenericErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    _AuAnalytics.default.trackException({
      description: error.toString() + ' ' + info.componentStack
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_react.default.createElement(_ClientSideError.default, this.props);
    }
    return this.props.children;
  }
}
exports.default = GenericErrorBoundary;